import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./public-home').then(c => c.PublicHome)
  },
  { 
    path: 'admin',
    loadComponent: () => import('./admin/admin').then(c => c.Admin)
  },
  {
    path: 'admin/event/:id',
    loadComponent: () => import('./admin/event-editor').then(c => c.EventEditor)
  },
  {
    path: 'admin/moderate/:id',
    loadComponent: () => import('./admin/moderation').then(c => c.Moderation)
  },
  {
    path: 'e/:id',
    loadComponent: () => import('./kiosk/kiosk').then(c => c.Kiosk)
  },
  {
    path: 'e/:id/selfie',
    loadComponent: () => import('./guest/guest-selfie').then(c => c.GuestSelfie)
  },
  {
    path: 'e/:id/selfie-access',
    loadComponent: () => import('./guest/selfie-access').then(c => c.SelfieAccess)
  },
  {
    path: 'e/:id/guest',
    loadComponent: () => import('./guest/guest-photo').then(c => c.GuestPhoto)
  },
  {
    path: 'e/:id/gallery',
    loadComponent: () => import('./gallery/gallery').then(c => c.Gallery)
  },
  {
    path: '**',
    loadComponent: () => import('./public-home').then(c => c.PublicHome)
  }
];
